/**
 * Modo de guardado de la edición inline de items de presupuesto.
 * - `confirmacion`: los cambios quedan pendientes hasta apretar el botón ✓ (✗ descarta).
 * - `auto`: los cambios se guardan al salir de la fila, con Enter, o al elegir en un select.
 */
export type ModoEdicionInline = 'confirmacion' | 'auto';

/** Cambiar a `'confirmacion'` para volver a los botones ✓ / ✗ de la edición inline. */
export const MODO_EDICION_COSTOS: ModoEdicionInline = 'auto';
